import {doc} from './docs.js';
import ZSubMix from '../custom/ZSubMix.js';
import ZMixButtons from '../custom/ZMixButtons.js';

doc("submix",
    {
    },
    "Mix between sub-sequences");

export const submix = (object) => {
    let mix = new ZSubMix(object);

    return () => {
        
    };
};

doc("mixbuttons",
    {
    },
    "Buttons to start/stop/record",
    () => 0,
    {
        inlets: 0
    });

export const mixbuttons = (object) => {
    let mix = new ZMixButtons(object);

    return () => {
        
    };
};

